import React from 'react';

import List from '../../atoms/List';
import { useDialog } from '../../atoms/Dialog';
import { ConfigChatbot, configChatbotList } from '../../../api';
import useApi from '../../../hooks/useApi';
import LoadingContainer from '../../hoc/LodingContainer';
import StringAssociativeArrayInterface from '../../../types/StringAssociativeArrayInterface';
//import FormConfigRadek from './FormConfigRadek';
import FormConfigSekce from './FormConfigSekce';
import { IConfRadek, IConfSekce } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cfgList1 = {
    "texts": {
        "name": "Chatbot RBP, vítám vás",
        "btnSendTitle": "Odeslat",
        "btnRenewTitle": "Zahájit novou konverzaci",
        "inputPlaceholder": "Napište Váš požadavek...",
        "messageRepeat": "opakovat dotaz",
        "btnExpandTitle": "Chci se zeptat chatbota",
        "btnCloseTitle": "Schovat chatbota",
        "messageError": "Jsem příliš zaneprázdněn, zkuste se zeptat později. :-(",
        "alert": "Dobrý den, tady Chatbot RBP. Mohu Vám pomoci?",
        "messageExpander": "více...",
        "messageCollapser": "méně..."
    },
    "styles": {
        "light": {
            "iconBgColor": "#00A3E0",
            "windowBgColor": "#FFF",
            "nameColor": "#FFF",
            "btnSendColor": "#00A3E0",
            "btnRenewColor": "#768295",
            "inputBgColor": "#E8E8E8",
            "inputTextColor": "#000",
            "messageInBgColor": "#091E2E",
            "messageInTextColor": "#FFF",
            "messageOutBgColor": "#00A3E0",
            "messageOutTextColor": "#FFF",
            "messageErrorColor": "#ff5768",
            "messageInfoColor": "#74737a",
            "faqBgColor": "#33A0D3",
            "faqTextColor": "#FFF",
            "iconImage": "e52da98c-3957-4eab-9ed1-8c1482f6f7fa.png",
            "fontFamily": "sans-serif",
            "logoImage": "a004a33c-3f2c-4632-9d24-1fae4953839d.jpg",
            "nameBgColor": "#00A3E0",
            "btnSendBgColor": "#FFF",
            "btnSendImage": "30001d79-f35e-46a4-a289-2216cf0bbcc0.png",
            "btnRenewBgColor": "#FFF",
            "btnRenewImage": "774bf0d5-519f-42a5-a875-0c00ac389e7c.png",
            "footerBgColor": "#FFF"
        },
        "dark": {
            "iconBgColor": "#00A3E0",
            "windowBgColor": "#FFF",
            "nameColor": "#FFF",
            "btnSendColor": "#00A3E0",
            "btnRenewColor": "#768295",
            "inputBgColor": "#E8E8E8",
            "inputTextColor": "#000",
            "messageInBgColor": "#091E2E",
            "messageInTextColor": "#FFF",
            "messageOutBgColor": "#00A3E0",
            "messageOutTextColor": "#FFF",
            "messageErrorColor": "#ff5768",
            "messageInfoColor": "#74737a",
            "faqBgColor": "#33A0D3",
            "faqTextColor": "#FFF",
            "iconImage": "e52da98c-3957-4eab-9ed1-8c1482f6f7fa.png",
            "fontFamily": "sans-serif",
            "logoImage": "a004a33c-3f2c-4632-9d24-1fae4953839d.jpg",
            "nameBgColor": "#00A3E0",
            "btnSendBgColor": "#FFF",
            "btnSendImage": "30001d79-f35e-46a4-a289-2216cf0bbcc0.png",
            "btnRenewBgColor": "#FFF",
            "btnRenewImage": "774bf0d5-519f-42a5-a875-0c00ac389e7c.png",
            "footerBgColor": "#FFF"
        }
    },
    "features": {
        "defaultOpen": false,
        "memoOpen": false,
        "onChatLinkClickAction": "AutoClose",
        "internalLinksTarget": "self",
        "externalLinksTarget": "new",
        "closeMode": "X",
        "footerMode": "ISR",
        "alertTimer": 5,
        "incommingMessageShowRows": 4
    }
}

const textsPopis: StringAssociativeArrayInterface<string> = {
    name: 'Název chatbota, zobrazuje se v otevřeném okně navrchu',
    btnSendTitle: 'Text tlačítka "odeslat dotaz", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené',
    btnRenewTitle: 'Text tlačítka "nová konverzace", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené',
    btnExpandTitle: 'Text tlačítka "otevřít chatbota", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené',
    btnCloseTitle: 'Text tlačítka "schovat chatbota", zobrazuje se po najetí myší a ve čtečce pro zrakově postižené',
    inputPlaceholder: 'Placeholder políčka pro psaní dotazu',
    messageRepeat: 'Text zobrazující se pod bublinou v chatu, když se nepodaří získat odpověď ze serveru.Vedle textu je refresh ikonka, která po kliknutí opakuje dotaz. Něco ve stylu "Odeslat znovu"',
    messageError: 'Text zobrazující se v bublině chatu, když se nepodaří získat odpověď ze serveru. Něco ve stylu "Teď nemohu odpovědět, zeptejte se mě později…" nebo "Něco se nepovedlo"',
    messageExpander: 'Text zobrazující se v bublině chatu, když je text příliš dlouhý. Rozbalovátko',
    messageCollapser: 'Text zobrazující se v bublině chatu, když je text příliš dlouhý. Sbalovátko',
    alert: 'Text zobrazující se v bublině, když na sebe chatbot upozorňuje'
}

const featuresPopis: StringAssociativeArrayInterface<string> = {
    defaultOpen: 'Výchozí rozbalenost / sbalenost chatbota', //boolean
    memoOpen: 'Pamatování si posledního stavu rozbalenosti chatbota', //boolean
    onChatLinkClickAction: 'Automatické skrývání / otevírání chatbota po kliknutí na vygenerovaný odkaz', //'AutoClose', 'AutoOpen'
    internalLinksTarget: 'Otevírání odkazů na stejné doméně ve stejném / novém okně', //'self', 'new'
    externalLinksTarget: 'Otevírání odkazů na jiné doméně ve stejném / novém okně', //'self', 'new'
    closeMode: 'Styl zavírání chatbota(křížek / ikonkou chatbota)', //'Z', 'expander'
    footerMode: 'Rozložení prvků v patičce chatbota', //'RIS', 'ISR'
    alertTimer: 'Čas po kterém na sebe chatbot upozorní', //integer
    incommingMessageShowRows: 'Počet řádků, které se zobrazí u příchozí zprávy' //integer
}

const stylesPopis = {
    logoImage: 'Nazev souboru s logem zákazníka',
    fontFamily: 'Font chatbota',
    iconImage: 'Název souboru s ikonkou chatbota',
    iconBgColor: 'Barva pozadí za rozbalovací ikonkou chatbota',
    windowBgColor: 'Barva pozadí okna',
    nameColor: 'Barva písma názvu chatbota',
    nameBgColor: 'Barva pozadí názvu chatbota',
    btnSendBgColor: 'Barva pozadí tlačítka "odeslat zprávu"',
    btnSendColor: 'Barva ikonky tlačítka "odeslat zprávu"',
    btnSendImage: 'Ikonka tlačítka "odeslat zprávu"',
    btnRenewBgColor: 'Barva pozadí tlačítka "nová konverzace"',
    btnRenewColor: 'Barva ikonky tlačítka "nová konverzace"',
    btnRenewImage: 'Ikonka tlačítka "nová konverzace"',
    inputBgColor: 'Barva pozadí políčka pro psaní zprávy',
    inputTextColor: 'Barva textu políčka pro psaní zprávy',
    messageInBgColor: 'Barva pozadí bubliny s příchozí zprávou',
    messageInTextColor: 'Barva textu bubliny s příchozí zprávou',
    messageInImage: 'Obrázek vedle bubliny s příchozí zprávou',
    messageOutBgColor: 'Barva pozadí bubliny s odchozí zprávou',
    messageOutTextColor: 'Barva textu bubliny s odchozí zprávou',
    messageOutImage: 'Obrázek vedle bubliny s odchozí zprávou',
    messageErrorColor: 'Barva textu chybové zprávy pod bublinou, když se nezdaří získat odpověď ze serveru',
    messageInfoColor: 'Barva textu info zprávy typu "připojil se operátor"',
    faqBgColor: 'Barva pozadí bubliny s FAQ',
    faqTextColor: 'Barva textu bubliny s FAQ',
    footerBgColor: 'Barva pozadí patičky'
}


function ConfigChatbotList() {
    const { data: cfgList, call: reload, ...loading } =
        useApi<ConfigChatbot, void>(configChatbotList({ autoFetch: true }));

    /*const [selectedRadek, setSelectedRadek] = useState<IConfRadek['idx'] | undefined>(undefined);*/
    const { openDialog } = useDialog();

    const upravText = (text: any): string => {
        if (text === false) return 'false';
        if (text === true) return 'true';
        if (text) return text;
        return '-';
    };

    const nastavRadky = (sekce: any, popis: any): Array<IConfRadek> => (
        Object.entries(popis).map((entry: any, idx: number) => {
            const klic = entry[0];
            return { idx, id: klic, text: upravText(sekce[klic]), popis: entry[1] };
        })
    );

    const textsData: any = cfgList?.texts || {};
    const texts = nastavRadky(textsData, textsPopis);

    const featuresData: any = cfgList?.features || {};
    const features = nastavRadky(featuresData, featuresPopis);

    const stylesLightData: any = cfgList?.styles?.light || {};
    const stylesLight = nastavRadky(stylesLightData, stylesPopis);

    const stylesDarkData: any = cfgList?.styles?.dark || {};
    const stylesDark = nastavRadky(stylesDarkData, stylesPopis);

    /*const cfgEditRadek = (id: any, sekce: Array<string>) => openDialog({
        title: 'Upravit hodnotu',
        content: (
            <FormConfigRadek
                reload={reload}
                id={id}
                sekce={sekce}
                data={cfgList} />
        ),
        onSuccess: () => document.getElementById('form-config-submit')?.click()
    });*/

    const cfgEditSekce = (sekceObj: IConfSekce) => openDialog({
        title: sekceObj.title,
        content: (
            <FormConfigSekce
                reload={reload}
                sekceObj={sekceObj}
                data={cfgList} />
        ),
        onSuccess: () => document.getElementById('form-config-submit')?.click()
    });

    const seznamSekce: Array<IConfSekce> = [
        { title: 'Texty', sekce: ['texts'], radky: texts },
        { title: 'Vlastnosti', sekce: ['features'], radky: features },
        { title: 'Styly pro světlý režim', sekce: ['styles', 'light'], radky: stylesLight },
        { title: 'Styly pro tmavý režim', sekce: ['styles', 'dark'], radky: stylesDark }
    ];

    return (
        <>
            <h1>Nastavení vzhledu chatbota</h1>
            <LoadingContainer {...loading} >
                {seznamSekce.map(itm => (
                    <div className='mt-32' key={itm.title}>
                        <List
                            title={itm.title}

                            columns={[
                                { key: 'id', label: 'Označení' },
                                { key: 'text', label: 'Hodnota' },
                                { key: 'popis', label: 'Popis' },
                            ]}
                            rows={itm.radky}
                            selectable='single'
                            /*selected={selectedRadek === undefined ? undefined : [selectedRadek]}*/
                            /*onChangeSelect={(ids) => setSelectedRadek(ids.length ? ids[0] : undefined)}*/
                            /*onEdit={(id) => cfgEditRadek(id, itm.sekce)}*/
                            onEditN={() => cfgEditSekce(itm)}
                        />
                    </div>
                ))}
            </LoadingContainer>
        </>
    );
}

export default ConfigChatbotList;
